import { render, staticRenderFns } from "./InputTextArea.vue?vue&type=template&id=340add24&scoped=true"
import script from "./InputTextArea.vue?vue&type=script&lang=ts"
export * from "./InputTextArea.vue?vue&type=script&lang=ts"
import style0 from "./InputTextArea.vue?vue&type=style&index=0&id=340add24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340add24",
  null
  
)

export default component.exports